/** Get Dashboard Chart data */
export const GET_CHARTS_DATA = 'GET_CHARTS_DATA';
export const GET_REFERRALS = 'GET_REFERRALS';
export const GET_INCOME = 'GET_INCOME';
